import * as CL from '@design-system/component-library';
import { LinkableAccordion } from '../../components/LinkableAccordion/index.js';
import { installationAddressMsg, noTechnicalDetailsAvailableMsg, t } from '../i18n/index.js';
import { getTaapiTechnologyAsString } from './subscriptionUtils.js';
import type { SubscriptionDetailsBroadband, SubscriptionDetailsMobile } from '../../generated/api/models.js';
import type { JSX } from 'react';

export type Accordion = {
  headerName: string;
  includedData: JSX.Element;
  id: string;
  displayed: boolean;
};

export const AccordionsMain = ({ accordions }: { accordions: Accordion[] }) => (
  <div>
    {accordions
      .filter(accordion => accordion.displayed)
      .map(accordion => (
        <LinkableAccordion key={accordion.id} heading={accordion.headerName} headingLevel="h3" id={accordion.id}>
          {accordion.includedData}
        </LinkableAccordion>
      ))}
  </div>
);

interface TechnicalInformationBroadbandProps {
  details?: SubscriptionDetailsBroadband;
}

interface TechnicalInformationMobileProps {
  details?: SubscriptionDetailsMobile;
}

export const TechnicalInformationBroadBand = ({ details }: TechnicalInformationBroadbandProps) =>
  details ? (
    <CL.Description
      items={[
        {
          title: t.DI4V(installationAddressMsg),
          description: details.installationAddress,
        },
        {
          title: t.F5BJ('Technology'),
          description: getTaapiTechnologyAsString(details.taapiTechnology),
        },
        {
          title: t.R4O4('Download speed'),
          description: details.downloadSpeed,
        },
        {
          title: t.CQQ7('Upload speed'),
          description: details.uploadSpeed,
        },
        {
          title: t.ECMJ('Device model'),
          description: details.deviceModel,
        },
        {
          title: t.OVGH('Device serial number'),
          description: details.serialNumber,
        },
      ].filter(item => !!item && item.description)}
    />
  ) : (
    <>{t.Q4XS(noTechnicalDetailsAvailableMsg)}</>
  );

export const TechnicalInformationMobile = ({ details }: TechnicalInformationMobileProps) =>
  details ? (
    <CL.Description
      items={[
        {
          title: t.ECMJ('Device model'),
          description: details.deviceModel,
        },
        {
          title: t.OVGH('Device serial number'),
          description: details.serialNumber,
        },
      ].filter(item => !!item && item.description)}
    />
  ) : (
    <>{t.Q4XS(noTechnicalDetailsAvailableMsg)}</>
  );
